import React from 'react';

import dayjs from '~/timeInit';

import { Box, Checkbox, FormControlLabel, Stack, TextField, Typography } from '@mui/material';

import { useUpdateExperienceValues } from '~/components/Experiences/hooks';
import useBrands from '~/components/Experiences/hooks/useBrands';

import { ORIGINAL_EXPERIENCE_CONTENT_TAB } from '~/consts/experiences';

import { OfferBrandSchedule } from '~/services/ExperiencesService';

function formatDate(dateStr?: string | null): string {
  if (!dateStr) return '—';
  const date = dayjs.utc(dateStr);
  if (!date.isValid()) return '—';
  return date.format('DD/MM/YYYY');
}

function toInputDate(dateStr?: string | null): string {
  if (!dateStr) return '';
  const date = dayjs.utc(dateStr);
  if (!date.isValid()) return '';
  return date.format('YYYY-MM-DD');
}

export default function ExperienceCurationTacticalSchedule() {
  const { values, updateValues, contentTab } = useUpdateExperienceValues();
  const { data: allBrands } = useBrands();

  const areOriginalValues = contentTab === ORIGINAL_EXPERIENCE_CONTENT_TAB;
  const brandSchedules = (values as { brandSchedules?: Array<OfferBrandSchedule> })?.brandSchedules;

  if (!brandSchedules?.length) return null;

  const getBrandName = (brandId: string): string => {
    const brand = allBrands?.find((b) => b.id === brandId);
    return brand?.name ?? brandId;
  };

  const handleChange = (index: number, field: keyof OfferBrandSchedule, value: string | boolean | null) => {
    const updated = brandSchedules.map((bs, i) => (i === index ? { ...bs, [field]: value } : bs));
    updateValues({ brandSchedules: updated });
  };

  return (
    <Box my={2}>
      <Typography fontWeight="bold" fontSize={16} mb={1}>
        Tactical Schedule per Brand
      </Typography>
      <Stack spacing={2}>
        {brandSchedules.map((bs, index) => {
          const tacticalEnabled = bs.tacticalEnabled ?? false;

          return (
            <Box key={bs.brandId} border={1} borderColor="grey.300" borderRadius={1} p={2}>
              <Typography fontWeight="bold" mb={1}>
                {getBrandName(bs.brandId)}
              </Typography>

              <Typography variant="body2" color="text.secondary" mb={1}>
                Run: {formatDate(bs.startDate)} &nbsp; Offline: {formatDate(bs.endDate)} &nbsp; Expiry:{' '}
                {formatDate(bs.expiryDate)}
              </Typography>

              <FormControlLabel
                control={
                  <Checkbox
                    checked={tacticalEnabled}
                    onChange={(e) => handleChange(index, 'tacticalEnabled', e.target.checked)}
                    disabled={areOriginalValues}
                  />
                }
                label="Tactical Enabled"
              />

              <Stack direction="row" spacing={2} mt={1}>
                <TextField
                  label="Tactical Promo Start"
                  type="date"
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  value={toInputDate(bs.tacticalPromoStart)}
                  onChange={(e) => handleChange(index, 'tacticalPromoStart', e.target.value || null)}
                  disabled={areOriginalValues || !tacticalEnabled}
                />
                <TextField
                  label="Tactical Promo End"
                  type="date"
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  value={toInputDate(bs.tacticalPromoEnd)}
                  onChange={(e) => handleChange(index, 'tacticalPromoEnd', e.target.value || null)}
                  disabled={areOriginalValues || !tacticalEnabled}
                />
              </Stack>
            </Box>
          );
        })}
      </Stack>
    </Box>
  );
}
